<template>
  <d2-container>
    <template slot="header">
      <el-form
        :inline="true"
        :model="searchForm"
        ref="searchForm"
        size="mini"
        style="margin-bottom: -18px;"
      >
        <el-form-item
                label="商家名称"
        >
          <el-input
                  v-model="searchForm.agentnamenew"
                  placeholder="商家名称"
                  style="width: 100px;"
          />
        </el-form-item>
        <el-form-item
          label="商品名称"
        >
          <el-input
            v-model="searchForm.agentname"
            placeholder="商品名称"
            style="width: 100px;"
          />
        </el-form-item>
        <el-form-item
                label="订单号"
        >
          <el-input
                  v-model="searchForm.order_id"
                  placeholder="订单号"
                  style="width: 100px;"
          />
        </el-form-item>
        <el-form-item>
          <el-date-picker
                  v-model="dateRange"
                  :picker-options="pickerOptions"
                  type="daterange"
                  range-separator="~"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"    width="150">

          </el-date-picker>

        </el-form-item>

        <el-form-item>
          <el-select
                  class="filter-item"
                  v-model="searchForm.stat"
                  placeholder="支付状态"
                  width="50"
          >
            <el-option
                    v-for="item in typeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
                  class="filter-item"
                  v-model="searchForm.is_qr"
                  placeholder="收货状态"
                  width="50"
          >
            <el-option
                    v-for="item in typeOptions2"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="handleSearchFormSubmit"
          >
            <d2-icon name="search" /> 查询
          </el-button>
        </el-form-item>

        <el-form-item>
          <el-button @click="handleSearchFormReset">
            <d2-icon name="refresh" /> 重置
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button
                  type="primary"
                  @click="handleExportFormSubmit"
          >
            <d2-icon name="share" /> 导出
          </el-button>
        </el-form-item>
      </el-form>
    </template>
    <el-button
      v-if="multipleSelection.length>0"
      type="danger"
      size="mini"
      icon="el-icon-delete"
      @click="batchDel"
    >
      删除
    </el-button>
    <el-table
      :data="tableData"
      v-loading="loading"
      size="small"
      stripe
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >

      <el-table-column
        type="selection"
        width="55"
      >
      </el-table-column>
      <el-table-column
        label="商铺名称"
      >
        <template slot-scope="scope">
          {{scope.row.agent_name}}
        </template>
      </el-table-column>

      <el-table-column
        label="商家LOGO"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.agent_logo!=null && scope.row.agent_logo!=''">
            <img :src= "getImgUrl(scope.row)" style="width: 100px;height: 100px; "/>
          </div>

        </template>
      </el-table-column>
      <el-table-column
        label="支付金额(元)"
      >
        <template slot-scope="scope">
          {{scope.row.amount}}
        </template>
      </el-table-column>
      <el-table-column
              label="订单号"
      >
        <template slot-scope="scope">
          {{scope.row.order_id}}
        </template>
      </el-table-column>
      <el-table-column
              label="下单时间"
      >
        <template slot-scope="scope">
          {{scope.row.insert_time2}}
        </template>
      </el-table-column>
      <el-table-column
              label="支付状态"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.stat=='0'">
            未支付
          </div>
          <div v-else-if="scope.row.stat=='1'">
            已支付
          </div>

        </template>
      </el-table-column>
      <el-table-column
              label="商家地址"
      >
        <template slot-scope="scope">
          {{scope.row.agent_adress}}
        </template>
      </el-table-column>
      <el-table-column
              label="商品图片"
      >

        <template slot-scope="scope">


          <div v-if="scope.row.good_url!=null && scope.row.good_url!=''">


             <span v-for="(item,index) in scope.row.good_url.split(',')">
              <span v-if="index==0">
                 <span v-if="item.indexOf('mp4') !=-1">
              <video
                      v-bind:src="getImgUrl2(scope.row)"
                      class="avatar video-avatar"
                      controls="controls"  style="width: 200px;height: 100px; "></video>
              </span>
              <span v-else>
                 <img :src= "getImgUrl2(scope.row)" @click="previewPic(scope.row)"  style="width: 200px;height: 100px; "/>
              </span>
              </span>
          </span>




          </div>


        </template>
      </el-table-column>
      <el-table-column
              label="商品名称"
      >
        <template slot-scope="scope">
          {{scope.row.order_content}}
        </template>
      </el-table-column>
      <el-table-column
              label="下单人"
      >
        <template slot-scope="scope">
          {{scope.row.user_name}}
        </template>
      </el-table-column>
      <el-table-column
              label="收件人"
      >
        <template slot-scope="scope">

          {{scope.row.consignee}}
        </template>
      </el-table-column>

      <el-table-column
              label="收货人电话"
      >
        <template slot-scope="scope">

          {{scope.row.consignee_tel}}
        </template>
      </el-table-column>

      <el-table-column
              label="收货人地址"
      >
        <template slot-scope="scope">

          {{scope.row.province_address}}{{scope.row.consignee_address}}
        </template>
      </el-table-column>
      <el-table-column
              label="单价(元)"
      >
        <template slot-scope="scope">
          {{scope.row.unit_price}}

        </template>
      </el-table-column>
      <el-table-column
            label="数量"
    >
      <template slot-scope="scope">
        {{scope.row.frequency}}
      </template>
    </el-table-column>
      <el-table-column
              label="类型"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.type_video=='0'">
            邮寄
          </div>
          <div v-else-if="scope.row.type_video=='1'">
            到店消费
          </div>
        </template>
      </el-table-column>
      <el-table-column
              label="快递名称"
      >
        <template slot-scope="scope">

          {{scope.row.express_name}}
        </template>
      </el-table-column>

      <el-table-column
              label="快递单号"
              width="150"
      >
        <template slot-scope="scope">


          {{scope.row.express_no}}
        </template>
      </el-table-column>
      <el-table-column
              label="交易是否完成"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.stat=='1'">
            <div v-if="scope.row.is_qr=='0'">
              未完成
            </div>
            <div v-else-if="scope.row.is_qr=='1'">
              已完成
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column
              label="是否退款"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.stat=='1'">
            <div v-if="scope.row.is_refund=='0'">
              否
            </div>
            <div v-else-if="scope.row.is_refund=='1'">
              是
            </div>
            <div v-else-if="scope.row.is_refund=='2'">
             退款申请中
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        align="center"
        width="330"
      >
        <template slot-scope="scope">
          <el-button type="primary" plain size="mini"   v-if="scope.row.stat=='1'"  @click="openViewForm(scope.row)">查看物流信息</el-button>
          <el-button type="primary" plain size="mini"   v-if="scope.row.is_refund!=='0'"  @click="openTkForm(scope.row)">查看退款信息</el-button>
          <el-button type="primary" plain size="mini"   v-if="scope.row.stat=='1' && scope.row.is_qr=='0'"  @click="qrsh(scope.row)">确认收货</el-button>
          <el-button type="primary" plain  size="mini"  v-if="scope.row.stat=='1' && scope.row.is_qr=='0'"   @click="openEditForm(scope.row)">快递编辑</el-button>
          <el-button type="primary" plain size="mini"   v-if="scope.row.stat=='0'"   @click="del(scope.row)">删除</el-button>
        </template>
      </el-table-column>

    </el-table>


     <!-- 图片预览 -->

          <el-dialog :visible.sync="dialogVisible" :modal="false" title="图片预览" width="50%">

            <img :src="previewpic" alt=""  width="100%" />

            <span slot="footer" class="dialog-footer">

              <el-button type="primary" @click="dialogVisible = false">确 定</el-button>

            </span>

          </el-dialog>

      <!-- 图片预览 -->
    <template slot="footer">
      <el-pagination
        :current-page="page.current"
        :page-size="page.size"
        :total="page.total"
        :page-sizes="[1,10,50,100, 200, 300, 400]"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: -10px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </template>
    <view-form
            :oneclass="oneclass"
            v-model="viewFormVisible"
            @submit="getTableData"
    />

    <tk-form
            :oneclass="oneclass"
            v-model="tkFormVisible"
            @submit="getTableData"
    />

    <edit-form
            :oneclass="oneclass"
            v-model="editFormVisible"
            @submit="getTableData"
    />

  </d2-container>
</template>
<script>
import * as memberService from "@/api/sys/member";
import * as agentService from "@/api/sys/agent";
import util from '@/libs/util.js'
import viewForm from "./viewForm";
import tkForm from "./tkForm";
import editForm from "./editForm";
export default {
  name: "MembergglPage",
  components: {viewForm,tkForm,editForm },
  data() {
    return {
      searchForm: {
          fxtel: "",
          legal: "",
        stat: "",
        is_qr: "",
        agentnamenew: "",
        agentname: "",
        order_id: "",
          userCode: ""
      },
      loading: false,
      dialogVisible: false,

      previewpic: "",
      tableData: [],
      multipleSelection: [],
        dateRange: [],
        pickerOptions:{},
        typeOptions: [
            {
                value: "1",
                label: "已支付"
            },
            {
                value: "0",
                label: "未支付"
            }
        ],
      typeOptions2: [
        {
          value: "1",
          label: "已收货"
        },
        {
          value: "0",
          label: "未收货"
        }
      ],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      sort: {
        prop: "",
        order: ""
      },
        oneclass: {},
        agentid:'',
      tkFormVisible: false,
      editFormVisible: false,
        viewFormVisible: false
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
      dateConversion(value) {
          if (value != null && value != "") {
              var d = new Date(value);
              //  var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
              var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
              console.info("===========date=========" + date);
              return date;
          }else{
              return "";
          }
      },
      getImgUrl(row){
          return "https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/"+row.agent_logo;
      },
    getImgUrl2(row){
        var good_url=row.good_url;
      if(good_url.match(",")){
        var str = good_url.split(',');
        good_url=str[0];
      }

      return "https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/"+good_url;
    },


    handleExportFormSubmit() {
      window.location.href=encodeURI(process.env.VUE_APP_API+"/moblieapp/integralorderExcel?start_time="+ this.dateConversion(this.dateRange[0])+"&end_time="+this.dateConversion(this.dateRange[1])+"&agentnamenew="+this.searchForm.agentnamenew+"&agentname="+this.searchForm.agentname+"&order_id="+this.searchForm.order_id+"&is_qr="+this.searchForm.is_qr+"&stat="+this.searchForm.stat+"&dl_type="+util.cookies.get('dl_type')+"&xt_id="+util.cookies.get('xt_id')+"&agentid="+util.cookies.get('agentid'));
    },

    previewPic(row) {

      var good_url=row.good_url;
      if(good_url.match(",")){
        var str = good_url.split(',');
        good_url=str[0];
      }

      this.previewpic ="https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/"+good_url;

      this.dialogVisible = true;

    },
    getTableData() {
      let query = {
        pageIndex: this.page.current,
        pageSize: this.page.size,
        sortBy: this.sort.prop,
          dl_type: util.cookies.get('dl_type'),
          xt_id: util.cookies.get('xt_id'),
          agentid: util.cookies.get('agentid'),
        start_time:this.dateConversion(this.dateRange[0]),
        end_time:this.dateConversion(this.dateRange[1]),
        descending: this.sort.order === "descending",
        filter: this.searchForm
      };
      agentService.myIntegralorderlist(query).then(data => {
        this.tableData = data.rows;
        this.page.total = data.totalCount;
      });
    },
    handleSearchFormSubmit() {
      this.getTableData();
    },
    handleSearchFormReset() {
      this.$refs.searchForm.resetFields();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSortChange(val) {
      this.sort.prop = val.prop;
      this.sort.order = val.order;
      this.getTableData();
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getTableData();
    },
      openViewForm(oneclass) {
          this.oneclass = oneclass;
          this.viewFormVisible = true;
        this.tkFormVisible = false;
      },

    openEditForm(oneclass) {
      this.oneclass = oneclass;
      this.editFormVisible = true;
      this.viewFormVisible = false;
      this.tkFormVisible = false;
    },

    openTkForm(oneclass) {
      this.oneclass = oneclass;
      this.viewFormVisible = false;
      this.tkFormVisible = true;
    },
    batchDel() {
      this.$confirm("确认删除？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消"
      }).then(() => {
          memberService
          .delCommentBath({
            ids: JSON.stringify(this.multipleSelection.map(s => s.id))
          })
          .then(() => {
            this.getTableData();
          });
      });
    },
    qrsh(oneclass) {
          let msg ="收货";
          this.$confirm("确认"+msg+"操作？", "确认信息", {
              distinguishCancelAndClose: true,
              confirmButtonText: msg,
              cancelButtonText: "取消"
          }).then(() => {
            agentService.qrIntegral({order_id:oneclass.order_id}).then(() => {
                  this.getTableData();
              });
          });
      },
    del(oneclass) {
      this.$confirm("确认删除？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "删除",
        cancelButtonText: "取消"
      }).then(() => {
        agentService.delIntegral({id:oneclass.id}).then(() => {
          this.getTableData();
        });
      });
    }
  }
};
</script>
